<template>
	<section v-if="partners[0]" class="partners">
		<div class="container">
			<div class="row">
				<div class="col-12">
					<h2 class="partners__headline">{{ $t("home.partners") }}</h2>
					<ul class="partners__list">
						<li v-for="partner in partners" class="partners__logo">
							<a :href="partner.url">
								<img class="partners__img" :src="`${ partner.logo }`" alt="">
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import axios from 'axios'

	export default {
		data () {
			return {
				partners: [],
				baseUrl: axios.defaults.baseURL
			}
		},
		methods: {
			getPartners () {
				axios.get('/api/partners/', {
				})
					.then(resp => {
						this.partners = resp.data
					})
			}
		},
		created () {
			this.getPartners()
		}
	}
</script>

<style lang="scss" scoped>
	@import "../styles/variables";

	.partners {
		padding: 65px 0 90px 0;
		background-color: $gray;
		&__headline {
			text-align: center;
			margin: 0;
			margin-bottom: 40px;
			font-family: $libre-bold;
			font-size: 64px;
			color: $gold-light;
		}
		&__list {
			display: flex;
			justify-content: center;
			align-items: center;
			flex-wrap: wrap;
		}
		&__logo {
			margin: 0 28px;
			display: inline-block;
			list-style: none;
		}
		&__img {
			max-width: 100%;
		}
	}

	@media (max-width: 767.98px) {
		.partners {
			padding: 45px 0 50px;
			background-color: $gray;
			&__headline {
				margin-bottom: 15px;
				font-size: 27px;
			}
			&__logo {
				margin: 0 20px 10px;
				display: inline-block;
				list-style: none;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/PartnersComponent.vue